import Vue from "vue";
import VueVimeoPlayer from "vue-vimeo-player";

Vue.use(VueVimeoPlayer);
